import router from './router'
import { getAccessToken } from '@/utils/auth'
import { isRelogin } from '@/config/axios/service'
import { useTitle } from '@/hooks/web/useTitle'
import { useNProgress } from '@/hooks/web/useNProgress'
import { usePageLoading } from '@/hooks/web/usePageLoading'
import { useDictStoreWithOut } from '@/store/modules/dict'
import { useUserStoreWithOut } from '@/store/modules/user'
import { usePermissionStoreWithOut } from '@/store/modules/permission'

const { start, done } = useNProgress()

const { loadStart, loadDone } = usePageLoading()

// 路由不重定向白名单
const whiteList = [
  '/login',
  '/social-login',
  '/sso',
  '/403',
  '/404',
  '/500',
]

// 路由加载前
router.beforeEach(async (to, _from, next) => {
  start()
  loadStart()
  const permissionStore = usePermissionStoreWithOut()

  // 初始化本地路由（用于侧边栏菜单渲染）
  if (permissionStore.getRouters.length === 0) {
    await permissionStore.generateRoutes()
  }

  if (getAccessToken()) {
    if (to.path === '/login') {
      next({ path: '/' })
    } else {
      // 已登录：加载字典和用户信息
      const dictStore = useDictStoreWithOut()
      const userStore = useUserStoreWithOut()

      if (!dictStore.getIsSetDict) {
        await dictStore.setDictMap()
      }
      if (!userStore.getIsSetUser) {
        isRelogin.show = true
        await userStore.setUserInfoAction()
        isRelogin.show = false
        // 刷新后首次进入，保持当前目标路由
        next({ ...to, replace: true })
      } else {
        next()
      }
    }
  } else {
    // 未登录
    if (whiteList.includes(to.path)) {
      next()
    } else {
      next(`/login?redirect=${to.fullPath}`)
    }
  }
})

router.afterEach((to) => {
  useTitle(to?.meta?.title as string)
  done() // 结束Progress
  loadDone()
})
